/**
 * @module utils/logger
 */
import isNil from "lodash/isNil";

const urlVars = new URLSearchParams(document.location.search);

let filterIsOn = false;

const globalLogger = {
  debugTarget: urlVars.get("debugTarget"),
  debugEnabled: urlVars.get("debug") === "true" || !isNil(urlVars.get("debugTarget")),
  setDebugTarget,
  debugFilters: [],
  emit(method, ...logArguments) {
    /* eslint-disable no-console */
    if (this.debugEnabled) {
      if (filterIsOn && this.debugFilters.length > 0) {
        this.debugFilters.forEach((filterName) => {
          [...logArguments].forEach((log) => {
            if (typeof log === "string") {
              const logMessage = log.toLowerCase();
              const matches = logMessage.indexOf(filterName) !== -1;

              matches && !isNil(console[method]) && console[method](...logArguments);
            }
          });
        });
      } else {
        !isNil(console[method]) && console[method](...logArguments);
      }
    }
    /* eslint-enable no-console */
  },
  log() {
    this.emit("log", ...arguments);
  },
  info() {
    this.emit("info", ...arguments);
  },
  warn() {
    this.emit("warn", ...arguments);
  },
  error() {
    this.emit("error", ...arguments);
  },
  table() {
    this.emit("table", ...arguments);
  },
  trace() {
    this.emit("table", ...arguments);
  },
  group() {
    this.emit("group", ...arguments);
  },
  groupCollapsed() {
    this.emit("groupCollapsed", ...arguments);
  },
  groupEnd() {
    this.emit("groupEnd", ...arguments);
  },
  isDebug() {
    return this.debugEnabled;
  }
};

function setDebugTarget() {
  if (this.debugTarget) {
    this.debugFilters = [cleanFilter(this.debugTarget)];
    filterIsOn = true;
  }
}

function cleanFilter(filterName) {
  return filterName.toLowerCase();
}

globalLogger.setDebugTarget();

export default globalLogger;
